// extracted by mini-css-extract-plugin
export default {"main":"cc9e04a118","tit":"_9da23071f7","maintitle":"c490a9f623","ylw":"_4f058ce9ad","white":"c27aedf205","mv_title":"_256e75a1b0","mv_nc":"f14ddbc9cf","mv_in":"d00e6277f2"};